import { render, staticRenderFns } from "./VEmailsDialogChange.vue?vue&type=template&id=81043eac"
import script from "./VEmailsDialogChange.vue?vue&type=script&lang=js"
export * from "./VEmailsDialogChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports